import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterDropdownButton } from '../filters-dropdown/FilterDropdownButton';
import { CustomDropdown } from '../../../../components/custom-dropdown/CustomDropdown';
import { FilterDropdownBox } from '../filters-dropdown/FilterDropdownBox';
import { FilterDropdown } from '../filters-dropdown/FilterDropdown';
import { searchConstants } from '../../../search-utils/searchConstants';
import styles from './search_filters_dates.module.scss';
import { FilterDropdownHeader } from '../filters-dropdown/FilterDropdownHeader';

type Props = {
  isSelected: boolean;
  label: string | null | undefined;
  track: Function;
};

export const SearchFiltersDates: FC<Props> = ({
  isSelected,
  children,
  label,
  track,
}) => {
  function onClick(toggle: Function, value: boolean) {
    return () => {
      track('date', value);
      toggle();
    };
  }

  return (
    <CustomDropdown>
      {(isOpen, toggle) => (
        <FilterDropdown>
          <FilterDropdownButton
            uppercase
            isSelected={isSelected}
            onClick={onClick(toggle, !isOpen)}
          >
            {label || <FormattedMessage id={searchConstants.filters.dates} />}
          </FilterDropdownButton>
          {isOpen && (
            <FilterDropdownBox>
              <FilterDropdownHeader
                onClick={
                  toggle as (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                  ) => void
                }
                title={<FormattedMessage id={searchConstants.filters.dates} />}
              />
              <div className={styles.container}>{children}</div>
            </FilterDropdownBox>
          )}
        </FilterDropdown>
      )}
    </CustomDropdown>
  );
};
